var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('components.partner.PersonSelection.label'),
      "hint": _vm.$t('components.partner.PersonSelection.hint'),
      "placeholder": _vm.$t('components.partner.PersonSelection.placeholder'),
      "loading": _vm.loadingLocal,
      "items": _vm.items,
      "item-text": "titleReadable",
      "search-input": _vm.search,
      "cache-items": _vm.cache,
      "required": "",
      "clearable": "",
      "flat": "",
      "outlined": "",
      "return-object": "",
      "data-test-company-selection": ""
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.search = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.search = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_vm.loadingLocal ? _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("components.partner.PersonSelection.searching")) + " ")])], 1)], 1) : _c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.search && _vm.search.length >= 2 ? _vm.$t("components.partner.PersonSelection.nonFound") : _vm.$t("components.partner.PersonSelection.for")) + " ")])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item,
            attrs = _ref.attrs,
            on = _ref.on;
        return [_c('refs-person', _vm._g(_vm._b({
          attrs: {
            "item": item,
            "data-test-vehicle-api-selection-item": ""
          }
        }, 'refs-person', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }